import { ResizableExtension } from '../model/ResizableExtension';

export class IFrameExtension extends ResizableExtension {
  name = 'iframe';

  createCommands() {
    return {
      insertIFrame: ({ src }) => (param) => {
        if (!src) {
          return false;
        }
        const { srcRegex } = this.options;
        if (srcRegex && !src.match(srcRegex)) {
          return false;
        }

        this.insertCommand(param, { src });
      },
    };
  }
}

export const createIFrameExtension = (options) => new IFrameExtension(options[0], { allowfullscreen: { default: 'true' } });
